import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DefaultDataServiceConfig, HttpUrlGenerator } from '@ngrx/data';
import { Store } from '@ngrx/store';
import moment from 'moment';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { EfaactDataService } from '../efaact.data-service';
import { FeeLevel } from './fee-level.model';

export const entityName = 'FeeSetup';

@Injectable()
export class FeeLevelDataService extends EfaactDataService<FeeLevel> {
    // selectors: EntitySelectors<FeeLevel>;
    constructor(
        http: HttpClient,
        httpUrlGenerator: HttpUrlGenerator,
        log: LoggingService,
        config: DefaultDataServiceConfig,
        store: Store
    ) {
        super(http, httpUrlGenerator, entityName, log, config, store);
    }

    mapItems(item: FeeLevel): FeeLevel {
        if (!item) {
            return;
        }
        return {
            ...item,
            id: item.FeeSetupID,
            FeeRetainPercentStartDate: moment(
                item.FeeRetainPercentStartDate
            ).isValid()
                ? moment(item.FeeRetainPercentStartDate).toDate()
                : null,
            EffectiveDate: moment(item.EffectiveDate).isValid()
                ? moment(item.EffectiveDate).toDate()
                : null
        };
    }
}
